import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  CountItemInToteExportCriteria,
  DestroyTransactionExportCriteria,
  MaterialRequestTransactionExportCriteria,
  ProductTagExportCriteria,
  ReduceToClearSummaryExportCriteria,
  SalesPerformanceExportCriteria,
  SalesTransactionExportCriteria,
  ShiftRecordExportCriteria,
  StoreExpenseExportCriteria,
  StoreOtherIncomeExportCriteria
} from '../models';
import { MyReportDownloadCriteria, MyReportListPagination, MyReportSearchCriteria } from '../models/my-report';
import { CafeStockExportCriteria } from '../models/stock/cafe-stock.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.report;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  exportSalesPerformance(criteria: SalesPerformanceExportCriteria) {
    return this.exportReport(this.envService.salesPerformance, criteria);
  }

  exportSalesTransaction(criteria: SalesTransactionExportCriteria) {
    return this.exportReport(this.envService.salesTransaction, criteria);
  }

  exportShiftSale(criteria: ShiftRecordExportCriteria) {
    return this.exportReport(this.envService.shiftRecord, criteria);
  }

  exportCountItemInTote(criteria: CountItemInToteExportCriteria) {
    return this.exportReport(this.envService.countItemInTote, criteria);
  }

  exportStoreOtherIncome(criteria: StoreOtherIncomeExportCriteria) {
    return this.exportReport(this.envService.storeOtherIncome, criteria);
  }

  exportMaterialRequestTransaction(criteria: MaterialRequestTransactionExportCriteria) {
    return this.exportReport(this.envService.materialRequestTransaction, criteria);
  }

  exportReduceToClearSummary(criteria: ReduceToClearSummaryExportCriteria) {
    return this.exportReport(this.envService.reduceToClearSummary, criteria);
  }

  exportDestroyTransaction(criteria: DestroyTransactionExportCriteria) {
    return this.exportReport(this.envService.destroyTransaction, criteria);
  }

  exportStoreExpense(criteria: StoreExpenseExportCriteria) {
    return this.exportReport(this.envService.storeExpense, criteria);
  }

  exportCafeStock(criteria: CafeStockExportCriteria) {
    return this.exportReport(this.envService.cafeStock, criteria);
  }

  exportProductTag(criteria: ProductTagExportCriteria) {
    return this.exportReport(this.envService.productTag, criteria);
  }

  exportReport<T>(path: string, exportCriteria: T) {
    const url = this.getFullUrlWithStoreCode(path, null);
    return this.http.post<any>(url, exportCriteria, {
      headers: this.headers,
      observe: 'body'
    });
  }

  searchMyReport(payload: MyReportSearchCriteria): Observable<MyReportListPagination> {
    const url = this.getFullUrlWithStoreCode(this.envService.myReport);
    const params = this.getParams(payload);
    return this.http.get<MyReportListPagination>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  onDownloadReport(criteria: MyReportDownloadCriteria) {
    const url = this.getFullUrl(this.envService.downloadReport, { reportNo: criteria.reportNo });

    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}
